<template>
  <div
    id="overlay"
    class="policy-overlay"
    v-if="showMe"
    v-on:click="closeOverlay()"
  ></div>
</template>

<script>
export default {
  name: 'overlay',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShow: function(newValue) {
      this.showMe = newValue
    },
  },
  data: function() {
    return {
      showMe: false,
    }
  },
  computed: {},
  methods: {
    closeOverlay: function() {
      this.$emit('closeOverlay')
    },
  },
  mounted: function() {
    console.log('overlay here.' + this.isShow)
  },
}
</script>

<style scoped>
#overlay {
  opacity: 0.15;
  background-color: #000000;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 8;
}
</style>
